/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { data } from "./config/showcased-asset-description";
import { useAsset } from "../pages/ShowcasedAssetDetail/provider";
import { OWNED_ASSETS } from "../pages/OwnedAssets/graphql/owned-assets.query";
import { GET_ASSET_DETAIL } from "../pages/OwnedAssetDetail/graphql/asset-detail.query";
import { SOUND, VIDEO , PDF} from "../assets"
import { toast } from "react-hot-toast";
import { humanize } from "uno-js";
import { getErrorMessage } from "../utils/error.message";
const MODULE_NAME = "ShowcasedAsset";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class ShowcasedAssetService {
    private static instance: ShowcasedAssetService;
    private vapp: VApplication;
    private imageServer;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
        this.imageServer = props?.imageServer;
    }
    public static getInstance(props: any = {}): ShowcasedAssetService {
        if (!ShowcasedAssetService.instance) {
            ShowcasedAssetService.instance = new ShowcasedAssetService(
                props
            );
        }
        return ShowcasedAssetService.instance;
    }

    async getAssetDescription() {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            return data;
        } catch (err) {
            getErrorMessage(err);
        }
    }

    async getAssets(size: number, offset: number) {
        const getassetsService = ShowcasedAssetService.getInstance();
        const { id } = useAsset();
        console.log("storeid-owned", id)
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                const res = await client.query({
                    query: OWNED_ASSETS,
                    variables: {
                        size: size,
                        offset: offset,
                        filter: {
                            state: ["showcased_real"]
                            // store:id
                        }
                    },
                    fetchPolicy: 'network-only'
                });
                log.success(MODULE_NAME, "get owned assets result: ", res);
                // return res?.data?.getAssets;
                if (res) {
                    let _data = res?.data?.getAssets?.data;

                    let results = _data?.map((item: any) => {

                        const imgUrl = item?.img;
                        const urlFormat = imgUrl?.replace(/^.*\/\/[^\/]+/, '');
                        const imgBBformat = imgUrl?.split('/');
                        const ibbFormat = imgBBformat[imgBBformat.length - 3]

                        let _img;
                        if (ibbFormat === "i.ibb.co") {
                            // _img =`${getassetsService.imageServer}/imgbb${urlFormat}/:/rs=h:500`
                            _img = item?.img

                        }
                        else {
                            //  _img = `${getassetsService.imageServer}${urlFormat}/:/rs=h:500`
                            _img = item?.img
                        }
                        console.log("mui", _img)

                        if (item?.type === "audio") {
                            _img = item?.thumbnail ?? SOUND
                        }
                        if (item?.type === "video") {
                            _img = item?.thumbnail ?? VIDEO
                        }

                        if(item?.type === "doc"){
                            _img = item?.thumbnail ?? PDF
                        }
                        


                        return ({
                            ...item,
                            img: _img,
                            storeId: id,
                            tag: null,
                            networkType: null,
                            // category: item?.tag?.toLowerCase(),
                            tokenId: item?.serialNo,
                            serialNo: `Rare #/${item?.serialNo}`,
                            subtitle: item?.subtitle?.replace(/<[^>]*>?/gm, '')?.replace(/&nbsp;/g, '')?.replace(/&quot;/g, '"')?.replace(/&.*;/g, ''),
                            audioDetail: item?.type === "audio" ? true : false,
                            videoDetail: item?.type === "video" ? true : false,
                            pdfDetail: item?.type === "doc" ? true : false,

                        })
                    })
                    return {
                        pagination: {
                            nextOffset: offset + res?.data?.getAssets?.pageSize,
                            totalItems: res?.data?.getAssets?.totalCount
                        },
                        results
                    }
                }
            }
        } catch (err) {
            getErrorMessage(err);
            return {
                pagination: {
                    nextOffset: 0,
                    totalItems: 0,
                },
                results: [],
            };
        }
    }

    _getActionButtons(data: any) {
        let _actionButtons: any = [];
        {
            _actionButtons.push(
                {
                    key: "unlist",
                    title: "Unlist From Showcase",
                },
            );
        }

        return _actionButtons;
    }

    _getMeta(data: any[], digitalTwin: string) {
        let _meta = [];

        data?.map((item: any) => {
            _meta.push({
                key: item?.name,
                value: item?.val,
                disp_type: item?.disp_type,
            });
        });


        _meta.push({
            key: "Digital Twin",
            value: digitalTwin,
        });

        return _meta;
    }

    _getImages(data: any, media: any, type: string) {

        const imgUrl = data?.img;
        const urlFormat = imgUrl?.replace(/^.*\/\/[^\/]+/, '');
        const imgBBformat = imgUrl?.split('/');
        const ibbFormat = imgBBformat[imgBBformat.length - 3]

        let _imgF;
        if (ibbFormat === "i.ibb.co") {
            // _imgF =`${getassetsDetailService.imageServer}/imgbb${urlFormat}/:/rs=h:500`
            _imgF = imgUrl

        }
        else {
            //  _imgF = `${getassetsDetailService.imageServer}${urlFormat}/:/rs=h:500`
            _imgF = imgUrl
        }
        let _img;

        if (type === "audio") {
            _img = {
                original: data?.thumbnail ?? SOUND,
                thumbnail: data?.thumbnail ?? SOUND,
                thumbnailHeight: "70",
                thumbnailClass: "image-thumb",
                type: "audio",
                embedUrl: imgUrl,
            }
        }
        if (type === "video") {
            _img = {
                original: data?.thumbnail ?? VIDEO,
                thumbnail: data?.thumbnail ?? VIDEO,
                thumbnailHeight: "70",
                thumbnailClass: "image-thumb",
                type: "video",
                embedUrl: imgUrl,
            }
        }
        if (type === "image") {
            _img = {
                original: _imgF,
                thumbnail: _imgF,
                thumbnailHeight: "70",
                thumbnailClass: "image-thumb",
            }
        }


        let _data = media?.map((item: any) => {
            console.log("insidde", item)

            const imgUrl = item?.src;
            const urlFormat = imgUrl?.replace(/^.*\/\/[^\/]+/, '');
            const imgBBformat = imgUrl?.split('/');
            const ibbFormat = imgBBformat[imgBBformat.length - 3]

            let _imgF;
            if (ibbFormat === "i.ibb.co") {
                // _imgF =`${getassetsDetailService.imageServer}/imgbb${urlFormat}/:/rs=h:500`
                _imgF = item?.src

            }
            else {
                //  _imgM = `${getassetsDetailService.imageServer}${urlFormat}/:/rs=h:500`
                _imgF = item?.src
            }

            //    const uriType = ele?.uri.match(/[^:]\w+\/[\w-+\d.]+(?=;|,)/)[0]
            const assetType = item?.type?.substring(0, item?.type?.indexOf('/'))
            // const assetType;
            let selectThumbnail;
            if (assetType === "video") {
                selectThumbnail = item?.thumbnail ?? VIDEO
            } else if (assetType === "audio") {
                selectThumbnail = item?.thumbnail ?? SOUND
            } else {
                selectThumbnail = _imgF
            }

            return {
                original: selectThumbnail,
                thumbnail: selectThumbnail,
                thumbnailHeight: "70",
                thumbnailClass: "image-thumb",
                embedUrl: item?.src,
                type: assetType,
            };
        });
        console.log("IMG_DETAIL", [_img, ..._data])

        let _images = [_img, ..._data]
        return _images;


    }

    _getCreator(data: any, state: any, ipfs: any) {
        if (state === "cid_verification_pending") {
            return {
                userName: data.name,
                userId: data.name,

            }
        } else {
            return {
                userName: data.name,
                userId: data.name,
                // link: "/swiss-timing",
                authProofUrl: ipfs,
            }
        }
    }

    _getAxButtons(resData: any) {
        let _buttons: any = [];
        if (resData) {
            _buttons.push({
                title: "View Proof of Transaction",
                link: resData
            })
        }
        return _buttons;
    }

    async getAssetDetail(assetId: string, assetGroup: string) {
        // console.log("myAssetGroup", assetGroup);
        const { storeId } = useAsset();
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                const res = await client.query({
                    query: GET_ASSET_DETAIL,
                    variables: {
                        tokenId: assetId,
                        tokenGroup: assetGroup,
                        storeId: storeId,
                    },
                    fetchPolicy: "network-only",
                });
                // console.log("inside service asset detail",res)
                if (res) {
                    let _data = res?.data?.getAsset;
                    let _found = {
                        idx: _data?.idx,
                        title: _data?.title,
                        subtitle: _data?.subtitle,
                        tokenId: _data?.serialNo,
                        serialNo: _data?.serialNo,
                        tag: _data?.tag?.toUpperCase(),
                        category: _data?.tag?.toLowerCase(),
                        // price: _data?.price,
                        meta: this._getMeta(_data?.attrs, _data?.digitalTwin),
                        // info: this._getInfoButtons(_data?.state),
                        createdBy: this._getCreator(_data?.creator, _data?.state, res?.data?.viewInIpfs),
                        ownedBy: {
                            userName: _data?.owner?.name,
                            userId: _data?.owner?.name,
                        },
                        type: _data?.type,
                        actions: this._getActionButtons(_data?.state),
                        images: this._getImages(_data, _data?.media, _data?.type),
                        info: this._getAxButtons(_data?.tx_proof),
                        nftProvenance: _data?.nftProvenance?.map(item => {
                            console.log("nftprov", item)
                            return ({
                                title: item?.title,
                                profile: {
                                    // userName: item?.from?.name ?? item?.to?.name,
                                    userName: item?.title === "Owned By" || item?.title ==="Minted By" ? item?.to?.name : item?.from?.name,
                                    fromAddress:item?.title === "Owned By" || item?.title ==="Minted By" ? item?.to?.address : item?.from?.address,
                                    link: item?.form?.link,
                                    tx_proof: item?.tx_proof,
                                    // fromAddress: item?.from?.address,
                                    // toAddress: item?.to?.address,
                                    authProofUrl: res?.data?.viewInIpfs
                                },

                                eventOccurence: {
                                    date: item?.date
                                },
                                meta: {
                                    ...item?.meta
                                }
                            })
                        }),
                        nftSMProvenance: _data?.nftProvenance?.map((item) => {
                            return {
                                data: [
                                    {
                                        tag: item?.from?.name ?? item?.to?.name,
                                        title: item?.title,
                                        subtitle: item?.from?.name ?? item?.to?.name,
                                        link: item?.form?.link,
                                        price: item?.meta?.priceInFiat ?? item?.meta?.priceInCrypto,
                                        date: item?.date,
                                        tx_proof: item?.tx_proof,
                                        fromAddress: item?.from?.address,
                                        toAddress: item?.to?.address,
                                        authProofUrl: res?.data?.viewInIpfs

                                    },
                                ],
                            };
                        }),
                    };
                    console.log("catt", _found);
                    if (_found) {
                        return _found;
                    }
                }
                log.success(MODULE_NAME, "get owned asset detail result: ", res);
            }
        } catch (err) {
            getErrorMessage(err);
        }
    }
}
